// JQuery の slideUp と同様の挙動
export function slideUp(el: HTMLElement, duration: number = 300): void {
  if (el.classList.contains("d-none")) return;

  // 現在の高さを取得してセット
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;

  // アニメーションの設定
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";

  // アニメーションで高さを0にする
  el.style.height = "0";
  el.style.paddingTop = "0";
  el.style.paddingBottom = "0";
  el.style.marginTop = "0";
  el.style.marginBottom = "0";

  const onTransitionEnd = () => {
    // アニメーション完了後の処理
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
    el.classList.add("d-none");
    el.removeEventListener("transitionend", onTransitionEnd);
  };

  el.addEventListener("transitionend", onTransitionEnd);
}

// JQuery の slideDown と同様の挙動
export function slideDown(el: HTMLElement, duration: number = 300): void {
  el.classList.remove("d-none");

  // 初期状態の設定
  let height = el.offsetHeight;
  el.style.height = "0";
  el.style.paddingTop = "0";
  el.style.paddingBottom = "0";
  el.style.marginTop = "0";
  el.style.marginBottom = "0";
  el.offsetHeight;

  // アニメーションのプロパティを設定
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";

  // アニメーション実行
  el.style.height = height + "px"; // 高さを元の値に戻す
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  const onTransitionEnd = () => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
    el.removeEventListener("transitionend", onTransitionEnd);
  };
  setTimeout(onTransitionEnd, duration);
}
